export type Currency = "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "NZD" | "USD"

export interface MarketData {
  market: string
  currencyCode: Currency
  currencySymbol: string
  locale: string
  name: string
}

export const marketsData: MarketData[] = [
  {
    market: "au",
    currencyCode: "AUD",
    currencySymbol: "AU$",
    locale: "en",
    name: "Australia",
  },
  {
    market: "ca",
    currencyCode: "CAD",
    currencySymbol: "CA$",
    locale: "en",
    name: "Canada",
  },
  {
    market: "ch",
    currencyCode: "CHF",
    currencySymbol: "CHF",
    locale: "en",
    name: "Switzerland",
  },
  {
    market: "eu",
    currencyCode: "EUR",
    currencySymbol: "€",
    locale: "en",
    name: "Europe",
  },
  {
    market: "gb",
    currencyCode: "GBP",
    currencySymbol: "£",
    locale: "en",
    name: "United Kingdom",
  },
  {
    market: "global",
    currencyCode: "USD",
    currencySymbol: "$",
    locale: "en",
    name: "Global",
  },
  {
    market: "nz",
    currencyCode: "NZD",
    currencySymbol: "NZ$",
    locale: "en",
    name: "New Zealand",
  },
  {
    market: "us",
    currencyCode: "USD",
    currencySymbol: "$",
    locale: "en",
    name: "United States",
  },
]

export const defaultMarketData = {
  market: "us",
  currencyCode: "USD",
  currencySymbol: "$",
  locale: "en",
  name: "United States",
} as MarketData
